import { PrivacyPolicy } from 'src/modules/PrivacyPolicy/PrivacyPolicy';

export default PrivacyPolicy;
